var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeroSection'),_c('ProductsSection'),_c('StatsSection'),_c('AboutSection'),_c('WhyUsSection'),_c('CTASection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }